// Page-level contexts wiring widgets to CustomizableDashboardPage.
import React, { createContext } from 'react'

// Drilldown: widgets fire `clickEntity({type, payload})` and the page
// opens the matching drawer. type: 'agent'|'criterion'|'scorecard'|'call'
export const EntityClickContext = React.createContext(() => {})

// Programmatic picker control: `pickEntity({value, label} | null)`
// switches the active scope tab's picker.
export const PickEntityContext = React.createContext(() => {})

// Read side of the pickers: { scorecard, agent, tag } -> option | null.
export const PickedEntityValuesContext = React.createContext({
  scorecard: null,
  agent: null,
})

// Opens the page-level "Browse calls" drawer. `openBrowseCalls(overrides?)`
// merges the caller's scope diff ({agents, scorecards, initialTier...})
// over the current dashboard filters.
export const BrowseCallsContext = createContext({
  openBrowseCalls: () => {},
})
